import React from "react";
import styled from "styled-components";
import { Theme } from "../../Theme";

// 라디오 버튼 그룹 전체를 감싸는 컨테이너
const RadioGroupContainer = styled.div`
    display: flex;
    gap: 24px; /* 옵션 사이의 간격 */
    font-family:
        -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
        sans-serif;
`;

// 숨겨진 실제 라디오 버튼
const HiddenInput = styled.input.attrs({ type: "radio" })`
    display: none; /* 화면에서 완전히 숨김 */
`;

// 커스텀 라디오 버튼 아이콘
// $checked prop을 받아 활성/비활성 상태를 제어합니다.
export const StyledRadio = styled.div`
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: ${(props) => (props.$checked && !props.$disabled ? "4px" : "1px")} solid
        ${(props) =>
        props.$disabled
            ? Theme.color.gray400
            : props.$checked
              ? props.$readOnly
                  ? Theme.color.gray400 // 변경 불가 시 기존 선택은 회색 테두리
                  : Theme.color.indigo450
              : Theme.color.zinc350};
    background-color: ${(props) => (props.$disabled ? Theme.color.gray400 : "#fff")};
    transition: all 0.2s ease;
    position: relative;
`;

// 라벨 텍스트
const LabelText = styled.span`
    font-size: ${(props) => props.fontSize || Theme.text.c3.fontSize};
    font-family: ${(props) => props.fontFamily || Theme.text.default.fontFamily};
    letter-spacing: ${(props) => props.letterSpacing || Theme.text.default.letterSpacing};
    line-height: ${(props) => props.lineHeight || Theme.text.default.lineHeight};
    font-weight: ${(props) => props.fontWeight || Theme.text.c3.fontWeight};
    color: ${(props) => props.fontColor || Theme.text.default.fontColor};
`;

// 클릭 가능한 영역 (아이콘 + 텍스트)
// <label> 태그를 사용하여 클릭 영역을 확장하고 웹 접근성을 높입니다.
const LabelContainer = styled.label`
    display: flex;
    align-items: center;
    gap: 8px; /* 아이콘과 텍스트 사이 간격 */
    cursor: ${(props) => (props.$disabled ? "not-allowed" : props.$readOnly ? "default" : "pointer")};
    opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
`;

// 라디오 버튼 컴포넌트
// readOnly: 값 변경은 막지만(클릭 무효) 선택 상태(체크) 스타일은 그대로 유지
const CustomRadios = ({ options, selectedOption, setSelectedOption, readOnly }) => {
    // 라디오 버튼 변경 핸들러
    const handleChange = (event) => {
        if (readOnly) return;
        setSelectedOption(event.target.value);
    };

    return (
        <RadioGroupContainer>
            {options.map((option) => (
                <LabelContainer key={option.value} $disabled={option.disabled} $readOnly={readOnly}>
                    <HiddenInput
                        name="noticeType" // name이 동일해야 그룹으로 묶입니다.
                        value={option.value}
                        checked={selectedOption === option.value}
                        onChange={handleChange}
                        disabled={option.disabled || readOnly}
                    />
                    <StyledRadio
                        $checked={selectedOption === option.value}
                        $disabled={option.disabled}
                        $readOnly={readOnly}
                    />
                    <LabelText>{option.label}</LabelText>
                </LabelContainer>
            ))}
        </RadioGroupContainer>
    );
};

export default CustomRadios;
